import { useEffect, useState } from 'react'

export type Countdown = {
  hours: string
  minutes: string
  seconds: string
}

const pad = (value: number): string => String(Math.max(0, value)).padStart(2, '0')

/**
 * Counts down from a fixed offset (default 23h 46m 32s) starting when the page loads.
 */
export function useCountdown(initialSeconds: number = 23 * 3600 + 46 * 60 + 32): Countdown {
  const [remaining, setRemaining] = useState<number>(initialSeconds)

  useEffect(() => {
    const id = window.setInterval(() => {
      setRemaining((prev) => (prev <= 0 ? 0 : prev - 1))
    }, 1000)
    return () => window.clearInterval(id)
  }, [])

  return {
    hours: pad(Math.floor(remaining / 3600)),
    minutes: pad(Math.floor((remaining % 3600) / 60)),
    seconds: pad(remaining % 60),
  }
}
